module.exports = __webpack_public_path__ + "img/1.d6cf74d7.png";